import React, { useState } from "react";
import { MdDone } from "react-icons/md";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { playAudio } from "../utils/btnAudio";
import { TbX } from "react-icons/tb";
import { GrLinkNext } from "react-icons/gr";
import { Spinner } from "@nextui-org/react";
import { Dark_White_mode } from "../utils/constants";

const MembershipCard = ({
  title,
  download_limit,
  handleBuySubscription,
  priceOutput,
  value,
  search_limit,
  price,
  description,
  view_react,
}) => {
  const navigate = useNavigate();

  const { isLoggedIn } = useSelector((state) => state.auth);

  // useState for loading
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(1);

  const handleInputChange = (event) => {
    const value = event.target.value;
    console.log(value, "valu");
    // Check if the entered value is within the desired range (1 to 9)
    if (value < 1) {
      console.log("iffff");
      setCount(1);
    } else if (value > 9) {
      console.log("lse iffff");
      setCount(9);
    } else {
      console.log("else");
      setCount(value);
    }
    // setCount(value);
  };

  const handleSubscription = () => {
    playAudio();
    if (!isLoggedIn) {
      navigate("/signin");
      return;
    }
    if (title !== "A La Carte") {
      handleBuySubscription(
        value === false ? price * count : price,
        title,
        search_limit * count,
        download_limit * count,
        setLoading
      );
    } else {
      handleBuySubscription(
        price * count,
        title,
        search_limit * count,
        download_limit * count,
        setLoading
      );
    }
  };

  return (
    <div
      className="relative flex flex-col h-full p-6 rounded-xl dark:bg-orange-300 bg-white backdrop-filter backdrop-blur-xl shadow-xl border sm:border-gray-400 border-gray-200"
      data-aos="fade-up"
      data-aos-delay="700"
    >
      <div className="mb-4 pb-4 border-b border-white ">
        <div className="flex justify-center">
          <div
            className="font-normal text-sm text-black mb-1 flex justify-center rounded-full py-1 px-4"
            style={{
              background:
                "linear-gradient(90deg, #DA70AC 0%, #CADC63 28%, #75DFA6 67%, #68D4EA 100%)",
            }}
          >
            {title}
          </div>
        </div>

        <div className=" items-baseline mb-2 py-2 flex  justify-center">
          {priceOutput[value][2].includes("yr") ? (
            <span className="text-xl font-semibold font-inter text-black">
              ${(+priceOutput[value][1] / 12).toFixed(2)}
            </span>
          ) : (
            <span className="text-xl font-semibold font-inter text-black">
              ${(priceOutput[value][1] * count).toFixed(2)}
            </span>
          )}
         {title !== "A La Carte" && <span className="text-medium text-black font-inter">/mo</span>}
        </div>
        {priceOutput[value][2].includes("yr") && (
          <div className="text-black text-sm mb-1 font-inter text-center pr-0">
            ${(+priceOutput[value][1]).toFixed(2)} When billed annually
          </div>
        )}
        <div className="text-black font-normal text-center text-xs">
          {description}
        </div>
      </div>
      {/* <div className="font-medium mb-3">Features include:</div> */}
      <ul className="text-black grow">
        <li className="flex items-center  mb-1 text-sm">
          <MdDone className=" text-sm mr-2" />
          <span>
            {download_limit * count} Recipe Downloads{" "}
            {/* {title !== "A La Carte" && <span>Per Month</span>} */}
          </span>
        </li>

        <li className="flex items-center mb-1 text-sm">
          <MdDone className="mr-2 text-sm" />

          <span>
            {search_limit * count} Dish searches{" "}
            {/* {title !== "A La Carte" && <span>Per Month</span>} */}
          </span>
        </li>
        <li className="flex items-center  mb-1 text-sm">
          <MdDone className="mr-2 text-sm" />

          <span>
            Access to Cookbook, Edit & Share Recipes{" "}
            {(title === "Explorer Membership" ||
              title === "Foodie Membership") && (
              <span>, Edit & Share Recipes</span>
            )}
          </span>
        </li>

        {view_react != null && (
          <li className="flex items-center mb-1 text-sm">
            <TbX className="text-lg mr-2" />

            <span>
              {title === "Basic Membership" && "View, React, and Download "}
              {title !== "Basic Membership" &&
                "View, React, Download and Post "}
              Recipes in Chopping Block (coming soon)
            </span>
          </li>
        )}
      </ul>
      <div className=" mt-4">
        <div>
          {title === "A La Carte" && (
            <>
              <div className={`flex justify-between items-center text-black`}>
                <span className={``}>Buy Multiple:</span>
                <span>(1-9)</span>
              </div>
              <input
                value={count}
                onChange={(e) => handleInputChange(e)}
                type="number"
                className="w-full bg-transparent border border-white mb-2 mt-1 text-black  focus:ring-orange-200 focus:border-orange-200 rounded-sm"
                max={9}
                min={1}
              />
            </>
          )}
        </div>
        <button
          onClick={handleSubscription}
          className="btn-sm text-white bg-[#FF4949] hover:bg-red-500 w-full h-10 font-inter rounded-full"
          href="#0"
        >
          <p className="flex items-center">
            {loading ? (
              <Spinner size={20} />
            ) : (
              <>
                Get Started
                <GrLinkNext className="ml-2" />
              </>
            )}
          </p>
        </button>
      </div>
    </div>
  );
};

export default MembershipCard;
